import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "@/components/blocks/home/HomePage";
import { getAgentContentUrls } from "@/lib/ai-content";
import { translations } from "@/lib/i18n";
import { buildPageFaq, buildPageSeo, loadPageLocale } from "@/lib/page-seo";
import { buildOrganizationStructuredData } from "@/lib/seo";

export const Route = createFileRoute("/{-$locale}/")({
	component: HomePage,
	loader: loadPageLocale,
	head: ({ loaderData }) => {
		if (!loaderData) return {};
		const { locale } = loaderData;
		return buildPageSeo("home", locale, {
			agentReadable: getAgentContentUrls("/", locale),
			structuredData: [
				buildOrganizationStructuredData(locale),
				buildPageFaq(translations[locale].home.faq.items),
			],
		});
	},
});
